import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	color: ${CSSVars.gray900};

	h1 {
		font-weight: 600;
		text-align: center;
		max-width: 930px;
		margin: 0 auto 40px;
		font-size: ${CSSVars.fontSize2XL};

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			margin: 0 auto 90px;
			font-size: ${CSSVars.fontSize4XL};
		}
	}

	.text-wrapper {
		max-width: 930px;
		margin: 0 auto;

		h5 {
			font-weight: 600;
			font-size: ${CSSVars.fontSizeLG};
			margin: 10px 0;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSizeXL};
			}
		}

		h2,
		.heading-2 {
			font-style: normal;
			font-weight: 600;
			line-height: 49px;
			margin: 0 0 100px;
			font-size: ${CSSVars.fontSize3XL};

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSize5XL};
			}

			+ h3 {
				margin-top: -80px;
			}
		}

		h3,
		.heading-3 {
			font-style: normal;
			font-weight: 300;
			font-size: ${CSSVars.fontSize2XL};
			line-height: 140%;
			margin: 40px 0 20px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSize4XL};
			}

			&.accented {
				font-weight: normal;
				font-weight: 600;
				line-height: 36px;
			}
		}

		h4,
		.heading-4 {
			font-style: normal;
			font-weight: 600;
			font-size: ${CSSVars.fontSizeLG};
			line-height: 140%;
			margin: 40px 0 20px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSizeXL};
			}
		}

		h6,
		.heading-6 {
			font-style: normal;
			font-weight: 600;
			line-height: 140%;
			margin: 10px 0 5px;
			font-size: ${CSSVars.fontSizeMD};

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSizeLG};
			}
		}

		table {
			border-top: 1px solid #333;
			border-left: 1px solid #333;
			margin: 40px auto;
			text-align: left;
			overflow: auto;

			tr {
				td {
					padding: 15px;
					border-right: 1px solid #333;
					border-bottom: 1px solid #333;
				}
			}
		}

		p {
			font-weight: 300;
			font-size: ${CSSVars.fontSizeMD};
			margin: 20px 0;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSizeLG};
			}
		}

		a {
			color: ${CSSVars.primary500};
			text-decoration: none;

			&:hover {
				text-decoration: underline;
			}
		}

		ul,
		ol {
			margin: 20px 0;
		}

		ul li {
			list-style: disc;
		}

		ol li {
			list-style: decimal;
		}

		li {
			margin: 0 20px 10px;

			ul {
				li {
					list-style: circle;
				}
			}
		}
	}
`;
